export const CONTRACT_TYPE = Object.freeze({ACQUISITION: 'Acquisition', SALE: 'Sale'});
export const CONTRACT_STATUS = Object.freeze({INTEREST: 'Interest', IN_PROGRESS: 'Negotiation', SIGNED: 'Signed'});
